import walmartLogo from '../assets/walmart_logo.png';
import cvsLogo from '../assets/cvs_logo.svg';
import dollarGeneralLogo from '../assets/dollar_general_logo.svg';
import sevenElevenLogo from '../assets/seven_eleven_logo.png';

/**
 * Static cash-deposit gallery data. Mirrors the widget's funding-location
 * directory + barcode instrument without hitting any API.
 */
export interface CashDepositMockMerchant {
  id: string;
  nameKey: string;
  logo: string;
  /** `merchantID` of the same chain in the VRS dump (`cashDepositStoresMock`). */
  vrsMerchantId?: string;
}

export const CASH_DEPOSIT_AMOUNT = 403;
export const CASH_DEPOSIT_CURRENCY = 'USD';
export const CASH_DEPOSIT_BARCODE_VALUE = '60641403298472901';
export const CASH_DEPOSIT_BARCODE_EXP_MINUTES = 30;
/** Amount the cashier typed in the mismatch demo (wrong tender). */
export const CASH_DEPOSIT_MISMATCH_ENTERED_AMOUNT = 400;

export const cashDepositMockMerchants: CashDepositMockMerchant[] = [
  {
    id: 'walmart',
    nameKey: 'stores.merchants.walmart',
    logo: walmartLogo,
    vrsMerchantId: '2430',
  },
  {
    id: 'cvs',
    nameKey: 'stores.merchants.cvs',
    logo: cvsLogo,
    vrsMerchantId: '1531',
  },
  {
    id: 'dollar-general',
    nameKey: 'stores.merchants.dollarGeneral',
    logo: dollarGeneralLogo,
    vrsMerchantId: '6737',
  },
  {
    id: 'seven-eleven',
    nameKey: 'stores.merchants.sevenEleven',
    logo: sevenElevenLogo,
    vrsMerchantId: '3797',
  },
];

/**
 * Bridges a store picked on the map (VRS `merchantID`) to the chain reel on
 * CashStoresPage. Chains the reel does not carry yet resolve to `null`, which
 * leaves that screen on its own default instead of pinning an unknown id.
 */
export const galleryMerchantIdForVrsId = (
  vrsMerchantId: string,
): string | null =>
  cashDepositMockMerchants.find((m) => m.vrsMerchantId === vrsMerchantId)?.id ??
  null;
